(function () {
  // Fisher–Yates sui figli di un container
  function shuffleChildren(container) {
    if (!container) return;
    const items = Array.from(container.children);
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      if (j !== i) container.insertBefore(items[j], items[i]);
      const tmp = items[i];
      items[i] = items[j];
      items[j] = tmp;
    }
  }

  function randomizeAllGrids() {
    document.querySelectorAll('[data-randomize-grid]').forEach((host) => {
      // L'attributo è sul wrapper esterno: cerchiamo la vera griglia del tema
      const grid = host.matches('.product-list') ? host : host.querySelector('.product-list');
      if (grid) shuffleChildren(grid);
    });
  }

  // Prima paint
  document.addEventListener('DOMContentLoaded', randomizeAllGrids);

  // Re-render sezioni (filtri/ordina in OS 2.0 / Stretch)
  document.addEventListener('shopify:section:load', randomizeAllGrids);
  document.addEventListener('shopify:section:render', randomizeAllGrids);

  // Osserva aggiunte dinamiche di card (load more / infinite scroll)
  function observeHost(host) {
    const grid = host.matches('.product-list') ? host : host.querySelector('.product-list');
    if (!grid) return;
    const obs = new MutationObserver((mutations) => {
      const added = mutations.some(m => m.type === 'childList' && m.addedNodes.length);
      if (added) shuffleChildren(grid);
    });
    obs.observe(grid, { childList: true });
  }

  function initObservers() {
    document.querySelectorAll('[data-randomize-grid]').forEach(observeHost);
  }

  document.addEventListener('DOMContentLoaded', initObservers);

  // Se il tema sostituisce la griglia via AJAX, ri-applichiamo shuffle + observers
  const globalObserver = new MutationObserver(() => {
    randomizeAllGrids();
    initObservers();
  });
  globalObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
